module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.baf72e9.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.eot
// module id = xyrm
// module chunks = 3